import misc from './misc';
import navbar from './navbar';
import error from './error';
import home from './home';
import toasts from './toasts';

export default {
    error,
    misc,
    navbar,
    home,
    toasts,
    display: 'English',
    dir: 'ltr',
};
